import type { FC } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

export const Home: FC<SvgIconProps> = (props) => (
  <SvgIcon width="24" height="24" {...props}>
    <g transform="translate(0.000000, 1.000000)">
      <path
        fillRule="evenodd"
        d="M21.687 11.773L12 2.625l-9.687 9.148 1.374 1.454L5 11.987V20a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-8.013l1.313 1.24 1.374-1.454zM17 10.098l-5-4.723-5 4.723V19h10v-8.902z"
        clipRule="evenodd"
      />
    </g>
  </SvgIcon>
)
